var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flag)?_c('Swiper',{ref:"swiper",attrs:{"tag":_vm.tag,"options":_vm.swiperOptions},on:{"ready":_vm.ready}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }